import React from 'react';
import { createSvgIcon } from '@material-ui/core';

export const GCPStorageIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
        <title>Icon_24px_CloudStorage_Color</title>
        <g data-name="Product Icons">
            <rect x="2" y="4" width="20" height="7" fill="#aecbfa" />
            <rect x="20" y="4" width="2" height="7" fill="#669df6" />
            <polygon points="22 4 20 4 20 11 22 4" fill="#4285f4" />
            <rect x="2" y="4" width="2" height="7" fill="#669df6" />
            <rect x="6" y="7" width="6" height="1" fill="#fff" />
            <rect x="15" y="6" width="3" height="3" rx="1.5" fill="#fff" />
            <rect x="2" y="13" width="20" height="7" fill="#aecbfa" />
            <rect x="20" y="13" width="2" height="7" fill="#669df6" />
            <polygon points="22 13 20 13 20 20 22 13" fill="#4285f4" />
            <rect x="2" y="13" width="2" height="7" fill="#669df6" />
            <rect x="6" y="16" width="6" height="1" fill="#fff" />
            <rect x="15" y="15" width="3" height="3" rx="1.5" fill="#fff" />
        </g>
    </svg>,
    'GCP Storage',
);

